module.exports = "<div class=flight-advanced-options><ol class=options-list><li class=item-check><checkbox class=\"styled_checkbox top-level btn btn-default\" id=DirectFlightsOnly ng-model=params.DirectFlightsOnly></checkbox><label class=elem-label for=DirectFlightsOnly><l10n>Direct flights only</l10n></label></li></ol></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/templates/multi-stop-more-options.html
// module id = 3712
// module chunks = 0